import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AnimatePresence, motion} from "motion/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck} from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import {faRotate} from "@fortawesome/pro-solid-svg-icons/faRotate";

import ProgressBar from "@/components/Global/ProgressBar/ProgressBar";
import styles from "./Synchronise.module.scss";
import {selectSyncState} from "@/features/sync/syncSelectors";
import {syncDone} from "@/features/sync";

export default function Synchronise() {
  const {isSynchronising = false, data = {}} = useSelector(selectSyncState);
  const [showBanner, setShowBanner] = useState(false);

  const totalOfItems = Object.values(data)?.length || 0;
  const itemsSynchronised = Object.values(data)?.filter(value => value).length || 0;

  const bannerCopy = isSynchronising ? "Synchronising" : "Synchronised!";
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSynchronising) {
      setShowBanner(true);
    }

    if (!isSynchronising && showBanner) {
      setTimeout(() => {
        setShowBanner(false);
      }, 2000);
    }
  }, [isSynchronising]);

  useEffect(() => {
    let timer;
    if (isSynchronising && totalOfItems !== itemsSynchronised) {
      timer = setTimeout(() => {
        dispatch(syncDone());
      }, 60000);
    }
    return () => {
      timer && clearTimeout(timer);
    };
  }, [isSynchronising, totalOfItems, itemsSynchronised]);

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          className={`${styles.container}`}
          initial={{opacity: 0, y: 50}}
          animate={{opacity: 1, y: 0}}
          exit={{opacity: 0, y: 50}}
          transition={{duration: 0.3}}
          key={"synchroniseBanner"}>
          <div className={styles.banner}>
            <div className="row mx-0 position-relative">
              <div className="col-12 py-3 text-center">
                {isSynchronising ? (
                  <FontAwesomeIcon icon={faRotate} className="me-2" spin />
                ) : (
                  <FontAwesomeIcon icon={faCircleCheck} className="me-2" />
                )}
                {bannerCopy}
              </div>
              <div className="col-12">
                <ProgressBar value={itemsSynchronised} maxValue={totalOfItems} />
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
